<template>
  <v-card :class="['bottom-sheet', { active: show ? true : false }]">
    <v-icon @click="$emit('close')" class="closeBtn">keyboard_backspace</v-icon>
    <div class="bottom-sheet-head">
      <h3>
        <flag class="flag" :iso="selectedProfile.nationality" />
        {{ selectedProfile.team_name }}
      </h3>
    </div>
    <div class="profile">
      <TeamData :user-data="selectedProfile" />
      <v-tabs
        class="tabs"
        fixed-tabs
        background-color="white"
        slider-color="light-green accent-4"
      >
        <v-tab href="#Vereinsdaten">Vereinsdaten</v-tab>
        <v-tab href="#Mannschaften">Teams</v-tab>
        <v-tab href="#Gallery">Galerie</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item :value="'Vereinsdaten'">
            <v-card class="overview-profile" flat>
              <v-list>
                <v-list-group no-action>
                  <template v-slot:activator>
                    <h3>Mehr Infos</h3>
                  </template>

                  <div>
                    <div class="history-content">
                      <div class="flex-row-wrap">
                        <div>
                          <label>Vereinsgründung</label>
                          {{ formatFoundedDate }}
                        </div>
                        <div>
                          <label>Stadionname</label>
                          {{ selectedProfile.stadionname }}
                        </div>
                        <div>
                          <label>Größte Erfolge bisher</label>
                          {{ selectedProfile.biggest_success }}
                        </div>
                        <div>
                          <label>Co-Trainer/-in</label>
                          {{ selectedProfile.co_trainer }}
                        </div>
                        <div>
                          <label>Torwarttrainer/in</label>
                          {{ selectedProfile.goalkeeper_trainer }}
                        </div>
                        <div>
                          <label>Fitnesstrainer/in</label>
                          {{ selectedProfile.fitness_trainer }}
                        </div>
                        <div>
                          <label>Athletiktrainer/in</label>
                          {{ selectedProfile.athletic_trainer }}
                        </div>
                        <div>
                          <label>Mentaltrainer/in</label>
                          {{ selectedProfile.mental_trainer }}
                        </div>
                        <div>
                          <label>Vereinsvorsitzende/r</label>
                          {{ selectedProfile.ceo }}
                        </div>
                        <div>
                          <label>Teammanager</label>
                          {{ selectedProfile.team_manager }}
                        </div>
                        <div>
                          <label>Physiotherapeut/in</label>
                          {{ selectedProfile.physiotherapeut }}
                        </div>
                        <div>
                          <label>Betreuer/in</label>
                          {{ selectedProfile.betreuer }}
                        </div>
                      </div>
                    </div>
                  </div>
                </v-list-group>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Mannschaften'">
            <v-card class="overview-profile" flat>
              <v-list
                v-if="selectedProfile.history && selectedProfile.history.length > 0"
              >
                <v-list-group
                  v-for="(item, i) in selectedProfile.history"
                  :key="i"
                  v-model="item.active"
                  no-action
                  v-show="item.team"
                >
                  <template v-slot:activator>
                    <div class="history-wrapper list-name">
                      <h3 v-text="`${item.team ? item.team : 'bitte angeben'}`"></h3>
                    </div>
                  </template>
                  <div class="flex-row-wrap">
                    <div>
                      <label>Mannschaft</label>
                      {{ item.team }}
                    </div>
                    <div v-if="item.category">
                      <label>Aktuelle Liga</label>
                      {{ item.category.league }}
                    </div>
                    <div>
                      <label>Trainer</label>
                      {{ item.trainer }}
                    </div>
                    <div>
                      <label>Co-Trainer</label>
                      {{ item.co_trainer }}
                    </div>
                  </div>
                </v-list-group>
              </v-list>
              <div v-else class="history-content">
                <h3>Bisher keine Mannschaften angegeben.</h3>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Gallery'">
            <v-card class="overview-career" flat>
              <div class="history-content">
                <GalleryContent
                  v-if="hasPictures"
                  :images="selectedProfile.galleryImages"
                />
                <div v-else class="history-content">
                  <h3>Bisher keine Galerie angelegt.</h3>
                </div>

                <LinkCard
                  v-if="hasLinks"
                  :links="selectedProfile.videolinks"
                  :title="'Videos'"
                />
                <LinkCard
                  v-if="hasArticles"
                  :links="selectedProfile.newslinks"
                  :title="'Zeitungsartikel'"
                />
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <div
      v-if="
        this.showMatchButtons &&
        (!this.user_data.already_matched ||
          (this.user_data.already_matched &&
            !this.user_data.already_matched.includes(selectedProfile.id)))
      "
      :class="[{ 'button-box-active': show ? true : false }, 'button-box-fixed']"
    >
      <v-btn
        @click="matchPlayer(selectedProfile, 'teams', userType)"
        :class="['menu-button main main-small', { activeBtn: show ? true : false }]"
      >
        MATCH NOW!
        <!-- <v-icon>person</v-icon> -->
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { db } from '@/db';
import GalleryContent from '@/components/settings/GalleryContent';
import LinkCard from '@/components/settings/LinkCard';
import TeamData from '../profile/TeamData';
import match from '../../mixins/match';

export default {
  name: 'team-match-sheet',

  components: {
    GalleryContent,
    LinkCard,
    TeamData,
  },

  mixins: [match],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedProfile: {
      type: Object,
      default: () => {},
    },
    showMatchButtons: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    tab: null,
  }),

  computed: {
    ...mapState(['user_data', 'userType']),

    getNationality() {
      if (this.selectedProfile.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.selectedProfile.nationality,
        );
        return found.item_text;
      }
      return '-';
    },

    formatFoundedDate() {
      if (!this.selectedProfile || !this.selectedProfilefounded) return null;

      const [year, month, day] = this.selectedProfile.split('-');
      return `${day}.${month}.${year}`;
    },

    formatDate() {
      if (!this.user_data.age) return null;

      const [year, month, day] = this.user_data.age.split('-');
      return `${day}.${month}.${year}`;
    },

    dateToAge() {
      if (!this.user_data.age) return null;
      const [year, month, day] = this.user_data.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const age = moment().diff(dateString, 'years');
      return age;
    },
    sortedHistory() {
      let sorted = [];
      if (this.selectedProfile.history) {
        sorted = this.selectedProfile.history.sort((a, b) =>
          a.season < b.season ? 1 : b.season < a.season ? -1 : 0,
        );
      }
      return sorted;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.settings-wrapper {
  padding-top: 60px;
  overflow: hidden;
}
</style>
